import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, PRIMARY, TERTIARY } from '@glu/buttons-react';
import { createUseStyles } from '@glu/theming';
import ModalNotification from 'components/modalNotification/ModalNotification';
import LocaleContext from 'components/locale';

const useStyles = createUseStyles({
  modalHeader: {
    marginBottom: 22,
    fontSize: 20
  },
  modalBody: {
    whiteSpace: 'pre-wrap',
    marginBottom: 48
  }
});

export const PaymentsConfirmationModalComponent = ({ header, onCancel, onProceed, title }) => {
  const locale = useContext(LocaleContext);
  const classes = useStyles();

  return (
    <ModalNotification
      variant="error"
      show
      onHide={onCancel}
      suppressIcon={false}
      data-qa="payments-confirmation-modal"
    >
      <div className="modalWrapper">
        <div className={classes.modalHeader}>{header.toUpperCase()}</div>
        <div className={classes.modalBody}>{title}</div>

        <Button className="btn btn-primary" variant={PRIMARY} onClick={onProceed}>
          {locale['common.continue']}
        </Button>

        <Button className="btn btn-tertiary" variant={TERTIARY} onClick={onCancel}>
          {locale['common.cancel']}
        </Button>
      </div>
    </ModalNotification>
  );
};

PaymentsConfirmationModalComponent.propTypes = {
  header: PropTypes.string,
  title: PropTypes.string,
  onProceed: PropTypes.func,
  onCancel: PropTypes.func
};
PaymentsConfirmationModalComponent.defaultProps = {
  header: '',
  title: '',
  onProceed() {},
  onCancel() {}
};

export default PaymentsConfirmationModalComponent;
